/**
 * utils/visualSplit.js
 *
 * Client-side mirror of backend/services/visual_inspection_splitter.py.
 * Used as a fallback when the API response does not yet include
 * `visual_inspection_items` (e.g. older scan rows whose processed_output was
 * generated before this feature shipped).
 */

export function isVisualNote(note) {
  if (!note || typeof note !== 'object') return false;
  const verif = note.verification_method;
  if (typeof verif !== 'string') return false;
  return verif.trim().toLowerCase().includes('visual');
}

function toVisualRow(note, itemNo) {
  const valueDetail = (note.value_detail || '').toString().trim();
  const noteLabel = (note.note_label || '').toString().trim();
  const specification = valueDetail || noteLabel || '';
  const verif = (note.verification_method || '').toString().trim();
  return {
    item_no: itemNo,
    specification,
    note_label: noteLabel,
    source_on_drawing: note.source_on_drawing || '',
    inspection_type: 'Visual',
    inspection_tool: verif || 'Visual',
    responsible_role: note.responsible_role || '',
    remarks: note.remarks || '',
    category: note.category || 'General Note',
    verification_method: verif,
    needs_review: !!note.needs_review,
    confidence_score:
      typeof note.confidence_score === 'number' ? note.confidence_score : 1.0,
  };
}

/**
 * Split notes into { visualItems, notesItems }, both renumbered 1..N.
 * `visualItems` carry the Visual Inspection row shape; `notesItems`
 * preserve the existing Notes Table row shape (just with refreshed item_no).
 */
export function splitVisualFromNotes(notesItems = []) {
  const visualItems = [];
  const notesRest = [];
  if (!Array.isArray(notesItems)) return { visualItems, notesItems: notesRest };

  notesItems.forEach((note) => {
    if (!note || typeof note !== 'object') return;
    if (isVisualNote(note)) {
      visualItems.push(toVisualRow(note, visualItems.length + 1));
    } else {
      notesRest.push({ ...note, item_no: notesRest.length + 1 });
    }
  });

  return { visualItems, notesItems: notesRest };
}
